import React from "react";
import ReactDOM from "react-dom/client";
import {RouterProvider} from "react-router-dom";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

// I18n and dates adapter
import {useTranslation} from "react-i18next";
import {getDateFnsLocale} from "./i18n";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import './i18n';

import router from "./router";
import AuthProvider from "./auth/AuthProvider";

// @mui material components
import {ThemeProvider} from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Material Dashboard 2 React themes
import theme from "materialDashboard/theme";
import {MaterialUIControllerProvider} from "./materialDashboard/context";
import {FeedbackProvider} from "./components/FeedbackTools";
import CurrentUserProvider from "./auth/CurrentUserProvider";
import LoadingOverlay from "./components/LoadingOverlay";


// Query client
const queryClient = new QueryClient()

// App component that handle locale
const App = () => {
    const { i18n } = useTranslation();
    const currentLocale = getDateFnsLocale(i18n.language);

    return <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
            <React.Suspense fallback={<LoadingOverlay />}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={currentLocale}>
                    <AuthProvider>
                        <MaterialUIControllerProvider>
                            <FeedbackProvider>
                                <CssBaseline/>
                                <CurrentUserProvider>
                                    <RouterProvider router={router}/>
                                </CurrentUserProvider>
                            </FeedbackProvider>
                        </MaterialUIControllerProvider>
                    </AuthProvider>
                </LocalizationProvider>
            </React.Suspense>
        </ThemeProvider>
        <ReactQueryDevtools initialIsOpen={false} position="bottom-right"/>
    </QueryClientProvider>
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>
);